import { Alert } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DocumentType } from '../../../api/dto';

interface LocationFacilityWarningProps {
    documentType: DocumentType.ACTIVITY | DocumentType.IS37;
}

export const LocationFacilityWarning: React.FC<LocationFacilityWarningProps> = ({ documentType }) => {
    const messageId = (
        { [DocumentType.ACTIVITY]: 'activity.locationFacility', [DocumentType.IS37]: 'is37.locationActivity' } as const
    )[documentType];
    return (
        <Alert severity="warning">
            <FormattedMessage id={messageId} />
        </Alert>
    );
};
